import { z } from "zod";

/** Orthopedic assessment — structured musculoskeletal exam. */

const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const orthoRegionSchema = z.enum([
	"knee",
	"shoulder",
	"hip",
	"spine",
	"ankle",
	"wrist",
	"elbow",
	"foot",
	"hand",
	"other",
]);
export type OrthoRegion = z.infer<typeof orthoRegionSchema>;

export const orthoSideSchema = z.enum(["left", "right", "bilateral", "na"]);
export type OrthoSide = z.infer<typeof orthoSideSchema>;

export const orthopedicAssessmentApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	assessment_date: dateStr,
	region: z.string().nullable(),
	side: z.string().nullable(),
	mechanism: z.string().nullable(),
	rom_notes: z.string().nullable(),
	motor_power: z.number().int().nullable(),
	special_tests: z.string().nullable(),
	neurovascular: z.string().nullable(),
	imaging_findings: z.string().nullable(),
	fracture_classification: z.string().nullable(),
	assessment: z.string().nullable(),
	plan: z.string().nullable(),
	notes: z.string().nullable(),
	recorded_by_member_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
});
export type OrthopedicAssessmentApi = z.infer<
	typeof orthopedicAssessmentApiSchema
>;

export const createOrthopedicAssessmentInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	assessment_date: dateStr,
	region: orthoRegionSchema.nullable().optional(),
	side: orthoSideSchema.nullable().optional(),
	mechanism: z.string().max(1000).nullable().optional(),
	rom_notes: z.string().max(1000).nullable().optional(),
	motor_power: z.coerce.number().int().min(0).max(5).nullable().optional(),
	special_tests: z.string().max(1000).nullable().optional(),
	neurovascular: z.string().max(1000).nullable().optional(),
	imaging_findings: z.string().max(2000).nullable().optional(),
	fracture_classification: z.string().max(500).nullable().optional(),
	assessment: z.string().max(2000).nullable().optional(),
	plan: z.string().max(2000).nullable().optional(),
	notes: z.string().max(2000).nullable().optional(),
});
export type CreateOrthopedicAssessmentInput = z.infer<
	typeof createOrthopedicAssessmentInputSchema
>;
